<template>
<div v-if="brokersLoading">
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
  <div v-else>
    <v-dialog scrollable v-model="loading" persistent max-width="200">
      <v-card>
        <v-card-title>{{ $t("globals.please_wait") }}</v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout row justify-center>
              <v-flex xs12 sm6 md4 lg3>
                <v-progress-circular indeterminate></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      scrollable
      v-model="confirmDeleteDialog"
      persistent
      max-width="400"
    >
      <material-card
        v-if="selectedItem"
        :title="$t('views.tags.delete_tag_{0}', [selectedItem.Name])"
        :color="$vuetify.theme.themes.light.error"
        icon="delete"
      >
        <v-card-text>{{ $t("globals.are_you_sure") }}</v-card-text>
        <v-card-actions>
          <v-btn color text @click="confirmDeleteDialog = false">
            {{ $t("Cancel") }}
          </v-btn>
          <v-btn color="error" text @click="deleteItem">
            {{ $t("globals.delete") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog scrollable v-model="editDialog" max-width="500px" persistent>
      <material-card :title="formTitle" :color="formColor" :icon="formIcon">
        <v-card-text>
          <v-form style="margin:20px" ref="form" v-model="valid">
            <v-row>
              <v-col xs="12" sm="12" md="12" lg="12">
                <no-autocomplete-textfield
                  v-model="editedItem.Name"
                  :label="$t('globals.name')"
                  required
                  :rules="[$rules.required]"
                  class="required"
                ></no-autocomplete-textfield>
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12">
                <v-textarea
                  v-model="editedItem.Description"
                  :label="$t('globals.description')"
                ></v-textarea>
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12">
                <auto-select
                  ref="brokers"
                  :value.sync="editedItem.Broker"
                  :items="brokers"
                  :label="$t('globals.broker')"
                  :rules="[$rules.required]"
                  item-text="Name"
                  item-value="Id"
                  return-object
                  :disabled="true"
                  class="required"
                ></auto-select>
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12">
                <trans-multi-select2
                  v-model="editedItem.Plans"
                  :items="plans"
                  :label="$t('globals.plans')"
                  :rules="[$rules.atLeastOne]"
                  field="Name"
                  itemValue="Id"
                  :canSelectAll="true"
                  class="required"
                ></trans-multi-select2>
                <!-- <v-autocomplete
                v-model="editedItem.Plans"
                :items="plans"
                :label="$t('globals.plans')"
                item-text="Name"
                item-value="Id"
                return-object
                multiple
                :rules="[$rules.atLeastOnePlan]"
              ></v-autocomplete> -->
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn :disabled="saving" text @click="close">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :disabled="!valid"
            :loading="saving"
            color="primary"
            @click="save"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-container
      fluid
      grid-list-md
      v-if="selectedBroker === null || selectedBroker === undefined"
    >
      <v-layout row justify-center>
        <v-flex xs12 sm6 md4 lg3>
          <v-card
            v-if="isLoggedIn && role.indexOf('Global Support Manager') > -1"
          >
            <v-card-text>
              <auto-select
                :value.sync="selectedBroker"
                :items="brokers"
                :label="$t('views.tags.select_broker')"
                prepend-icon="supervised_user_circle"
                return-object
                item-text="Name"
                item-value="Id"
                :loading="brokersLoading"
              ></auto-select>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <material-card
      v-else
      :title="$t('components.vuematerialdashboard.core.appbar.tags')"
      :color="$vuetify.theme.themes.light.secondary"
      icon="label"
    >
      <pbas-data-table
        :exporters="$exporters"
        ref="table"
        :dataProvider="provider"
        :showSelect="false"
        :rowActions="rowActions"
        :floatActions="floatActions"
        :fileNamePrefix="tableTitle"
        @itemsChanged="setData($event)"
        identifier="tagsTable"
        @error="error = $event"
      ></pbas-data-table>
      <!--<data-table
        ref="table"
        :headers="headers"
        :title="tableTitle"
        tableKey="Id"
        :rowActions="rowActions"
        :floatActions="floatActions"
        :selectAll="true"
        @odataItems="setData($event)"
        :displayFunctions="displayFunctions"
        :columnsOptions="columnsOptions"
        @customHeaders="saveHeaders($event)"
        :provider="provider"
      ></data-table>-->
      <v-snackbar
        v-model="snackbar"
        :color="color"
        :multi-line="mode === 'multi-line'"
        :timeout="timeout"
        :vertical="mode === 'vertical'"
      >
        {{ $t(message) }}
        <v-btn dark text @click="snackbar = false">
          {{ $t("globals.close") }}
        </v-btn>
      </v-snackbar>
    </material-card>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
//import DataTable from "../components/DataTable";
import { ODataProvider } from "pbas-vue-components";
import TagsHeaders from "../headers/Tags";
import ErrorHandler from "../components/ErrorHandler";
import AutoSelect from "../components/AutoSelect";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";
import TransMultiSelect2 from "../components/TransMultiSelect2.vue";

export default {
  name: "tags-table",
  components: {
    //DataTable,
    ErrorHandler,
    AutoSelect,
    NoAutocompleteTextfield,
    TransMultiSelect2
  },
  data() {
    return {
      selectedItem: null,
      error: null,
      brokersLoading: true,
      provider: undefined,
      selectedBroker: null,
      saving: false,
      columnsOptions: {},
      floatActions: [
        {
          name: "addTag",
          icon: "add",
          color: this.$vuetify.theme.themes.light.success,
          text: "globals.add_new",
          handler: this.add,
        },
      ],
      rowActions: [
        {
          name: "editItem",
          icon: "edit",
          title: "globals.edit",
          handler: this.editItem,
        },
        {
          name: "deleteItem",
          icon: "delete",
          title: "globals.delete",
          handler: (item) => {
            this.selectedItem = item;
            this.confirmDeleteDialog = true;
          },
        },
      ],
      tableTitle: "Tags",
      snackbar: false,
      color: "",
      mode: "",
      timeout: 2500,
      message: "",
      confirmDeleteDialog: false,
      customizeColumnsDialog: false,
      brokers: [],
      valid: false,
      plans: [],
      editDialog: false,
      tags: [],
      headers: TagsHeaders,
      displayFunctions: {
        brokerDisplayFunc: (item) => this.brokerDisplayFunc(item),
        plansDisplayFunc: (item, html) => this.plansDisplayFunc(item, html),
      },
      editedIndex: -1,
      editedItem: {
        Name: "",
        Description: "",
        Plans: [],
        Broker: null,
      },
      defaultItem: {
        Name: "",
        Description: "",
        Plans: [],
        Broker: null,
      },
      loading: false
    };
  },
  computed: {
    ...mapGetters("common", ["messages"]),
    odataUrl() {
      return "brokers/" + this.selectedBroker.Id + "/tags";
    },
    formTitle() {
      return this.editedIndex === -1
        ? this.$t("views.tags.create_new_tag")
        : this.$t("views.tags.edit_tag_{0}", [this.editedItem.Name]);
    },
    formIcon() {
      return this.editedIndex === -1 ? "add" : "edit";
    },
    formColor() {
      return this.editedIndex === -1 ? this.$vuetify.theme.themes.light.success : this.$vuetify.theme.themes.light.primary;
    },
    ...mapGetters("auth", ["isLoggedIn", "user", "role"]),
  },
  watch: {
    "editedItem.Broker": {
      handler(v) {
        if (v) {
          this.editedItem.BrokerId = this.editedItem.Broker.Id;
        } else {
          this.editedItem.BrokerId = null;
        }
      },
    },
    selectedBroker: {
      async handler(v) {
        if (v) {
          try {
            this.loading = true;
            this.plans = (await this.getOrganizationPlans(v.Id)).data.value;
            this.columnsOptions["plans"] = this.plans;
            this.provider = new ODataProvider(
              this.$axiosHttp,
              this.odataUrl,
              this.headers
            );
          } catch (error) {
            this.error = error;
          } finally {
            this.loading = false;
          }
        }
      },
    },
  },
  async mounted() {
    try {
      this.brokers = (await this.getOrganizations()).data.value;
      var usr = await this.getUser();
      if (this.brokers.length === 1) {
        this.selectedBroker = this.brokers[0];
      } else if (this.role.indexOf("Global Support Manager") > -1) {
        this.selectedBroker = null;
      } else if (this.role.indexOf("Broker Support Admin") > -1) {
        this.selectedBroker = this.brokers.filter(
          (o) => o.Id === usr.profile.brokerid
        )[0];
      }
      this.columnsOptions["brokers"] = this.brokers;
      this.brokersLoading = false;
    } catch (error) {
      this.error = error;
    }
  },
  methods: {
    /*/*$t(args) {
        console.log(this.messages, args)
        if (Object.keys(this.messages).indexOf(args) < 0) {
            this.messages[args]="TRANSLATION REQUIRED"
        }
        return "TRANSLATION REQUIRED";
    },*/
    ...mapActions("auth", ["getUser"]),
    ...mapActions("applicationUsers", [
      "getOrganizationPlans",
      "getOrganizations",
      "newTag",
      "updateTag",
      "deleteTag",
      "getTag",
    ]),
    setData(items) {
      this.tags = items;
    },
    saveHeaders(headerscopy) {
      this.headers = JSON.parse(JSON.stringify(headerscopy));
    },
    brokerDisplayFunc(item) {
      return item.Broker.Name;
    },
    plansDisplayFunc(item, html) {
      var res = "";
      if (item.Plans) {
        res = item.Plans.map((u) => u.Name).join(", ");
      }
      if (html)
        return (
          "<div style='word-wrap: break-word; white-space: pre-wrap;'>" +
          res +
          "</div>"
        );
      else return res;
    },
    add() {
      this.editedItem.Broker = this.selectedBroker;
      this.editDialog = true;
    },
    async editItem(item) {
      this.editedIndex = this.tags.indexOf(item);
      try {
        this.editedItem = (await this.getTag({
          broker: this.selectedBroker.Id,
          id: item.Id,
        })).data; //Object.assign({}, item);
        //this.editedItem.planscopy = JSON.parse(JSON.stringify(this.editedItem.plans))
        this.editDialog = true;
      } catch (error) {
        this.error = error;
      }
    },
    async deleteItem() {
      try {
        this.saving = true;
        await this.deleteTag({
          broker: this.selectedBroker.Id,
          tagId: this.selectedItem.Id,
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.confirmDeleteDialog = false;
        await this.$refs.table.getDataAsync();
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    close() {
      this.editDialog = false;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
      this.$refs.form.resetValidation();
    },
    async save() {
      this.saving = true;
      //this.editedItem.plans = JSON.parse(JSON.stringify(this.editedItem.planscopy))
      let item = JSON.parse(JSON.stringify(this.editedItem));
      item.BrokerId = item.Broker.Id;
      delete item.Broker;
      for (let plan of item.Plans) {
        delete plan.Tags;
      }
      if (this.editedIndex > -1) {
        try {
          await this.updateTag({ broker: this.selectedBroker.Id, tag: item });
          this.color = "success";
          this.message = "globals.success";
          this.snackbar = true;
          this.close();
          this.$refs.table.getDataAsync();
        } catch (error) {
          this.error = error;
        }
      } else {
        try {
          await this.newTag({ broker: this.selectedBroker.Id, tag: item });
          this.color = "success";
          this.message = "globals.success";
          this.snackbar = true;
          this.close();
          this.$refs.table.getDataAsync();
        } catch (error) {
          this.error = error;
        }
      }
      this.saving = false;
    },
  },
};
</script>
